const testimonials = [
  { name: "María García", role: "Madre de familia", text: "Escucho 'El Peregrino' mientras llevo a mis hijos a la escuela. Ha transformado mis mañanas." },
  { name: "Pastor Roberto", role: "Líder de iglesia", text: "Recomiendo Senda de Vida a toda mi congregación. El contenido es excelente y la narración es impecable." },
  { name: "Ana López", role: "Estudiante de teología", text: "Los PDFs de estudio son perfectos para mis clases. Y los audiolibros me acompañan en el transporte." },
];

export function Testimonials() {
  return (
    <section className="py-24 bg-section-alt">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-12">
          Lo que dicen nuestros oyentes
        </h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-card rounded-xl p-6 border border-border">
              <p className="text-foreground mb-4 italic leading-relaxed">"{t.text}"</p>
              <div>
                <p className="font-heading font-bold text-foreground text-sm">{t.name}</p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
